const confusedFeelings = [
  'Ne pas préciser',
  'Hésitant.e',
  'Partagé.e',
  'Divisé.e',
  'Tiraillé.e',
];

export default confusedFeelings;
